import { baseApi } from "./base.api";

export const reviewsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchFeaturedReviews: build.query({
      query: (limit = 6) => ({ url: "/reviews/featured", method: "GET", params: { limit } }),
      providesTags: ["Review"],
    }),
    fetchReviews: build.query({
      query: (product_id) => ({ url: `/reviews/product/${product_id}`, method: "GET" }),
      providesTags: (_r, _e, product_id) => [{ type: "Review", id: product_id }],
    }),
    fetchAllReviews: build.query({
      query: (params) => ({ url: "/reviews/admin/all", method: "GET", params }),
      providesTags: ["Review"],
    }),
    createReview: build.mutation({
      query: (formData) => ({ url: "/reviews/create", method: "POST", body: formData }),
      invalidatesTags: (_r, _e, fd) => [{ type: "Review", id: fd.get("product_id") }, "Review"],
    }),
  }),
});

export const { useFetchFeaturedReviewsQuery, useFetchReviewsQuery, useFetchAllReviewsQuery, useCreateReviewMutation } = reviewsApi;
